import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { flatMap, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SsoService {

	constructor(private _http: HttpClient) { }
	
	ssoGetLoginUrl(username) {
		let encodedUsername = encodeURIComponent(username);
		return `${environment.apiUrl}/v2/Sso/InetUser?username=${encodedUsername}`;
	}
	
	validateSsoLogin(username) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Sso/InetUser/Validate`, JSON.stringify(username));
	}
}
